import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon/index";
import { TooltipEl } from "common/components/tooltip/index";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-settings-section-container"
  }, this.attr(`title`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-settings-section-header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-settings-section-title"
  }, this.attr(`title`), this.attr(`help-text`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-settings-section-help-text-container"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "max-width": this.attr(`tooltip-max-width`), text: this.attr(`help-text`) }
  })) : null), this.attr(`help-link-url`) ? /* @__PURE__ */ jsx("a", {
    attrs: { href: this.attr(`help-link-url`), target: `_blank` }
  }, this.attr(`help-link-text`)) : null, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `header-actions` }
  })) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-settings-section-ul"
  }, /* @__PURE__ */ jsx("slot", null)));
}
